import React, { useRef, useEffect } from "react";
import { Link } from "react-router-dom";
import { MapPin, Clock, Phone, Envelope } from "@phosphor-icons/react";
import { animateContactInfo } from "./gsap-footer";

const ContactInfo = () => {
  const contactRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    if (contactRef.current) {
      // Add a small delay to ensure footer animation has started
      const timer = setTimeout(() => {
        if (contactRef.current) {
          animateContactInfo(contactRef.current);
        }
      }, 600);

      return () => clearTimeout(timer);
    }
  }, []);

  return (
    <>
      <h1 className="text-xl font-bold mb-5 text-cannabis-green-300">
        Visit Our Dispensary
      </h1>
      <address ref={contactRef} className="not-italic space-y-4">
        <div className="flex items-start p-3 rounded-lg hover:bg-cannabis-green-500/10 transition-colors duration-300">
          <MapPin
            size={20}
            className="text-cannabis-green-300 mr-3 mt-1 flex-shrink-0"
          />
          <p className="text-gray-400">
            3400 Connecticut Avenue NW
            <br />
            Washington, DC 20008
          </p>
        </div>

        <div className="flex items-start p-3 rounded-lg hover:bg-cannabis-green-500/10 transition-colors duration-300">
          <Clock
            size={20}
            className="text-cannabis-green-300 mr-3 mt-1 flex-shrink-0"
          />
          <p className="text-gray-400">Open Daily: 10am - 8pm</p>
        </div>

        <div className="pt-4">
          <Link
            to="/contact"
            className="inline-block btn-primary"
            aria-label="Contact Street Lawyer Services cannabis dispensary"
          >
            Contact Us
          </Link>
        </div>
      </address>
    </>
  );
};

export default ContactInfo;
